<template>
  <div class="container">
    <div class="row margin-top">
      <div class="col-8 offset-2">
        <div class="row medium-font">
          <div class="col-3">
            <a href="#">
              <!--<h3><strong><span class="arrow-font">&#x2190;</span> Go back</strong></h3>-->
            </a>
          </div>
          <div class="col-6 text-center">
            <h3><strong>Grow your business with mod24</strong></h3>
          </div>
        </div>
        <div class="row big-font">
          <div class="col text-center">
            <p>
              <strong>
                Email address has been verified
                <br />
                Lets complete the profile setup
              </strong>
            </p>
          </div>
        </div>
      </div>
      <div class="col-8 offset-2 background">
        <form @submit.prevent="update" @keydown="clearError($event)" autocomplete="no">
          <div class="form-row padding-bottom">
            <div class="col">
              <input
                v-model="info.first_name"
                id="first_name"
                name="first_name"
                type="text"
                class="form-control login-input"
                placeholder="Name"
              />
              <error-field :errors="errors" field="first_name" />
            </div>
            <div class="col">
              <input
                v-model="info.last_name"
                id="last_name"
                name="last_name"
                type="text"
                class="form-control login-input"
                placeholder="Last name"
              />
              <error-field :errors="errors" field="last_name" />
            </div>
          </div>
          <div class="form-row padding-bottom">
            <div class="col">
              <div class="input-group">
                <input
                  v-model="info.password"
                  id="password"
                  type="password"
                  name="password"
                  class="form-control login-input"
                  placeholder="Password"
                />
                <div class="input-group-append">
                  <span class="input-group-text">
                    <i class="fa fa-question-circle-o popup" />
                  </span>
                  <div id="myTemplate" style="display: none; align-content: flex-start;">
                    <p>Password must meet the following criteria:</p>
                    <ul class="text-left">
                      <li>8 characters long</li>
                      <li>1 uppercase letter</li>
                      <li>1 lowercase letter</li>
                      <li>1 number</li>
                    </ul>
                  </div>
                </div>
              </div>
              <error-field :errors="errors" field="password" />
            </div>
            <div class="col">
              <input
                v-model="info.password_confirmation"
                id="password_confirmation"
                name="password_confirmation"
                type="password"
                class="form-control login-input"
                placeholder="Confirm password"
              />
              <error-field :errors="errors" field="password_confirmation" />
            </div>
          </div>
          <input type="submit" class="btn btn-primary form-control login-button"
                 value="Register"
                 :disabled="errors.any()"
          />
        </form>
      </div>
      <div class="col-8 offset-2">
        <div class="row">
          <div class="col text-right">
            <a href="#" class="thick-font">Need help?</a><br />
            <p class="info-text">Visit our knowledge base</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import tippy from 'tippy.js';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';

export default {
  name: 'Update',
  components: {
    ErrorField,
  },
  data: () => ({
    info: {
      first_name: '',
      last_name: '',
      password: '',
      password_confirmation: '',
    },
    errors: new Errors(),
  }),
  mounted() {
    tippy('.popup', {
      placement: 'bottom',
      html: '#myTemplate',
    });
  },
  methods: {
    ...mapActions(['authSetData']),
    update() {
      axios
        .put('companies/update', { ...this.info, verification_code: this.$route.params.token })
        .then(res => {
          this.authSetData(res.data);
          this.$router.push({ name: 'VerifyPhone' });
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/Update.vue